import React, { Component } from 'react';

class TopBarNavMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isToggleOn: false
        }
    }

    async componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            await this.setState({
                isToggleOn: !this.state.isToggleOn
            });
        }
    }


    showDropdown(e, index) {
        e.preventDefault();
        this.props.getActiveIndex(index);
        //this.setState(prevState => ({
        //    isToggleOn: !prevState.isToggleOn
        //}));
    }

    render() {
        const classDropdownMenu = 'dropdown-menu navbar-dark' + (this.props.isActive === this.props.index ? ' show' : '');

        return (
            <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="Javascript:" id="navbarDropdown" role="button" data-toggle="dropdown"
                    onClick={(e) => { this.showDropdown(e, this.props.index)}}>
                    {this.props.name}
                </a>
                {this.props.children && <div className={classDropdownMenu}>
                    {this.props.children}
                </div>}
            </li>
        );
    }
}

export default TopBarNavMenu;